var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 145 145", width: "500", height: "500" }, props),
    React.createElement(
      "g",
      { id: "Layer" },
      React.createElement("path", { id: "Layer", fillRule: "evenodd", className: styles["shp0"] || "shp0", d: "M123.5 22c13.6 13.6 21.1 31.7 21.1 50.9s-7.5 37.3-21.1 50.9c-13.6 13.6-31.7 21.1-50.9 21.1s-37.3-7.5-50.9-21.1C8.1 110.2.6 92.1.6 72.9S8.1 35.6 21.7 22C35.3 8.4 53.4.9 72.6.9c19.3 0 37.3 7.5 50.9 21.1zM2.7 72.8c0 38.6 31.3 69.9 69.9 69.9 38.6 0 69.9-31.3 69.9-69.9 0-38.6-31.3-69.9-69.9-69.9C34 2.9 2.7 34.2 2.7 72.8z" }),
      React.createElement("path", { id: "Layer", className: styles["shp0"] || "shp0", d: "M106.1 94.7c-6.8-4.9-17.4-2.3-23.9-11 0 0-2.4-2.7 3-9.4 5.5-6.7 5.9-17.4 4.6-25.6C88.4 40.5 80.7 35 72.6 35s-15.8 5.5-17.2 13.7c-1.4 8.2-.9 18.9 4.6 25.6 5.5 6.7 3 9.4 3 9.4-6.5 8.7-17 6.1-23.9 11-6.9 4.9-5.2 16-5.2 16h77.4s1.7-11.1-5.2-16z" })
    )
  );
});